import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import { EMBER_ROUTE_NAMES } from "sh-www/constants/routes";

class PeopleCenterIndexRoute extends Route {
  @service() router;
  @service() session;

  redirect() {
    const { currentUser } = this.session;
    if (currentUser.isSeller) {
      this.router.replaceWith(EMBER_ROUTE_NAMES.DASHBOARD);
    }

    this.router.replaceWith(EMBER_ROUTE_NAMES.PEOPLE_CENTER__MY_NETWORK);
  }
}

export default PeopleCenterIndexRoute;
